import { combineReducers } from 'redux';

import { miscConstants } from '../constants';
import { FavStock } from '../py-generated/datalouder/favorite_stock/types';
import { UserWinData } from '../types';

interface ListTutorialsState {
  loading?: boolean;
  tutorialVideos?: any[];
  error?: Error;
}
const listTutorialVideos = (
  state: ListTutorialsState = {},
  action
): ListTutorialsState => {
  switch (action.type) {
    case miscConstants.LIST_TUT_VID_REQUEST:
    case miscConstants.ADD_TUT_VID_REQUEST:
    case miscConstants.UPDATE_TUT_VID_REQUEST:
    case miscConstants.ORDER_TUT_VID_REQUEST: {
      return {
        loading: true,
      };
    }

    case miscConstants.LIST_TUT_VID_SUCCESS:
    case miscConstants.ADD_TUT_VID_SUCCESS:
    case miscConstants.UPDATE_TUT_VID_SUCCESS:
    case miscConstants.ORDER_TUT_VID_SUCCESS: {
      return {
        tutorialVideos: action.tutorialVideos,
      };
    }

    case miscConstants.LIST_TUT_VID_FAILURE:
    case miscConstants.ADD_TUT_VID_FAILURE:
    case miscConstants.UPDATE_TUT_VID_FAILURE:
    case miscConstants.ORDER_TUT_VID_FAILURE: {
      return {
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

const listYoutubePlaylistVideo = (
  state: ListTutorialsState = {},
  action
): ListTutorialsState => {
  switch (action.type) {
    case miscConstants.LIST_TUT_VID_REQUEST: {
      return {
        loading: true,
      };
    }

    case miscConstants.LIST_TUT_VID_SUCCESS: {
      return {
        tutorialVideos: action.tutorialVideos,
      };
    }

    case miscConstants.LIST_TUT_VID_FAILURE: {
      return {
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

export interface FavStocksState {
  loading?: boolean;
  stocks?: FavStock[];
}
const favStocks = (state: FavStocksState = {}, action): FavStocksState => {
  switch (action.type) {
    case miscConstants.LIST_FAV_STOCK_REQUEST: {
      return {
        stocks: state.stocks,
        loading: true,
      };
    }

    case miscConstants.LIST_FAV_STOCK_SUCCESS: {
      return {
        stocks: action.stocks,
      };
    }

    case miscConstants.ADD_FAV_STOCK: {
      return {
        stocks: [
          ...state.stocks.filter(
            s =>
              !(
                s.id === action.stock.id && s.category === action.stock.category
              )
          ),
          action.stock,
        ],
      };
    }

    case miscConstants.REMOVE_FAV_STOCK: {
      return {
        stocks: state.stocks.filter(
          s =>
            !(
              (s.id === action.stockId || s.ticker === action.stockId) &&
              s.category === action.category
            )
        ),
      };
    }

    default: {
      return state;
    }
  }
};

interface ListPostsState {
  read?: any[];
  unread?: any[];
  clientReadPostIds?: number[];
  loading?: boolean;
}
const listPosts: (state: ListPostsState, action) => ListPostsState = (
  state: ListPostsState = {},
  action
) => {
  switch (action.type) {
    case miscConstants.LIST_POSTS_REQUEST: {
      return {
        loading: true,
        read: state.read,
        unread: state.unread,
      };
    }

    case miscConstants.LIST_POSTS_SUCCESS: {
      return {
        read: action.read,
        unread: action.unread,
      };
    }

    case miscConstants.LIST_POSTS_FAILURE: {
      return {
        error: action.error,
      };
    }

    case miscConstants.READ_POST: {
      return {
        ...state,
        clientReadPostIds: state.clientReadPostIds
          ? [...state.clientReadPostIds, action.postId]
          : [action.postId],
      };
    }

    default: {
      return state;
    }
  }
};

const syncPreference = (state = {}, action) => {
  switch (action.type) {
    case miscConstants.STORE_PREF_REQUEST:
    case miscConstants.LOAD_PREF_REQUEST: {
      return { loading: true };
    }
    case miscConstants.STORE_PREF_SUCCESS:
    case miscConstants.LOAD_PREF_SUCCESS: {
      return {};
    }

    case miscConstants.STORE_PREF_FAILURE:
    case miscConstants.LOAD_PREF_FAILURE: {
      return {
        error: action.error,
      };
    }
    default: {
      return state;
    }
  }
};

interface ListTutorialsState {
  tutorials?: any[];
  loading?: boolean;
}

const listTutorials = (state: ListTutorialsState = {}, action) => {
  switch (action.type) {
    case miscConstants.LIST_TUTORIALS_REQUEST: {
      return {
        loading: true,
        tutorials: action.tutorials,
      };
    }

    case miscConstants.LIST_TUTORIALS_SUCCESS: {
      return {
        tutorials: action.tutorials,
      };
    }

    case miscConstants.LIST_TUTORIALS_FAILURE: {
      return {
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

const loadUserWinRates = (
  state: {
    loading?: boolean;
    myRanks?: UserWinData;
  } = {},
  action
) => {
  switch (action.type) {
    case miscConstants.LOAD_USER_WIN_RATES_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case miscConstants.LOAD_USER_WIN_RATES_SUCCESS: {
      return {
        ...state,
        myRanks: action.myRanks,
        loading: false,
      };
    }

    case miscConstants.LOAD_USER_WIN_RATES_FAILURE: {
      return {
        ...state,
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

export default combineReducers({
  listTutorialVideos,
  listYoutubePlaylistVideo,
  favStocks,
  listPosts,
  syncPreference,
  listTutorials,
  loadUserWinRates,
});
